module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', [_c('span', {
    staticClass: "glyphicon glyphicon-user"
  }), _vm._v(" " + _vm._s(_vm.loggedUser.get('name')))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-add-request",
      "to": {
        name: 'RequestOpen'
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Abrir Requisição\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "tab",
    class: {
      active: (_vm.tabs.active == 'mine')
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('mine')
      }
    }
  }, [_c('a', [_vm._v("Minhas Requisições "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.userRequestsCount))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab",
    class: {
      active: (_vm.tabs.active == 'linked')
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('linked')
      }
    }
  }, [_c('a', {
    attrs: {
      "id": "linked-requests-panel-link"
    }
  }, [_vm._v("Requisições Vinculadas em Aberto "), _c('span', {
    staticClass: "badge badge-notifications"
  }, [_vm._v(_vm._s(_vm.linkedRequestsCount))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab",
    class: {
      active: (_vm.tabs.active == 'invites')
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('invites')
      }
    }
  }, [_c('a', {
    attrs: {
      "id": "linked-requests-panel-link"
    }
  }, [_vm._v("Convites de Requisições "), _c('span', {
    staticClass: "badge badge-notifications"
  }, [_vm._v(_vm._s(_vm.invitedRequestsCount))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab",
    class: {
      active: (_vm.tabs.active == 'workflows')
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('workflows')
      }
    }
  }, [_c('a', {
    attrs: {
      "id": "workflows-panel-link"
    }
  }, [_vm._v("Fluxos que sou responsável "), _c('span', {
    staticClass: "badge badge-notifications"
  }, [_vm._v(_vm._s(_vm.reponsibleWorkflowsCount))])])])]), _vm._v(" "), (_vm.tabs.active == 'mine') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userRequestsPerPage),
      expression: "userRequestsPerPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userRequestsPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getUserRequests]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUserRequests.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.userRequestsFilter),
      callback: function($$v) {
        _vm.userRequestsFilter = $$v
      },
      expression: "userRequestsFilter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "user-requests",
      "items": _vm.userRequests,
      "fields": _vm.userRequestsfields,
      "striped": "",
      "hover": "",
      "show-empty": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {
          staticClass: "glyphicon glyphicon-file"
        })
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [_vm._v(" " + _vm._s(item.value.get('name')))])
      }
    }, {
      key: "workflow",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n                " + _vm._s(item.value.get('name')) + "\n            ")])
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('span', {}, [(item.item.workflow.get('feedback')) ? _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search",
          attrs: {
            "title": "Ver Requisição"
          }
        }), _vm._v(" Ver/Editar\n              ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestConfirmation',
              params: {
                requestId: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-ok",
          attrs: {
            "title": "Ver Confirmação"
          }
        }), _vm._v(" Confirmação\n              ")])], 1)
      }
    }], null, false, 486712661)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  })]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.userRequestsCount,
      "per-page": _vm.userRequestsPerPage
    },
    on: {
      "input": _vm.getUserRequests
    },
    model: {
      value: (_vm.userRequestsCurrentPage),
      callback: function($$v) {
        _vm.userRequestsCurrentPage = $$v
      },
      expression: "userRequestsCurrentPage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tabs.active == 'linked') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkedRequestsPerPage),
      expression: "linkedRequestsPerPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.linkedRequestsPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getLinkedRequests]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getLinkedRequests.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.linkedRequestsFilter),
      callback: function($$v) {
        _vm.linkedRequestsFilter = $$v
      },
      expression: "linkedRequestsFilter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "linked-requests",
      "items": _vm.linkedRequests,
      "fields": _vm.linkedRequestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-file"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "workflow",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "owner",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n          ")])
      }
    }], null, false, 1359373302)
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.linkedRequestsCount,
      "per-page": _vm.linkedRequestsPerPage
    },
    on: {
      "input": _vm.getLinkedRequests
    },
    model: {
      value: (_vm.linkedRequestsCurrentPage),
      callback: function($$v) {
        _vm.linkedRequestsCurrentPage = $$v
      },
      expression: "linkedRequestsCurrentPage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tabs.active == 'invites') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invitedRequestsPerPage),
      expression: "invitedRequestsPerPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.invitedRequestsPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getInvitedRequests]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInvitedRequests.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.invitedRequestsFilter),
      callback: function($$v) {
        _vm.invitedRequestsFilter = $$v
      },
      expression: "invitedRequestsFilter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "linked-requests",
      "items": _vm.invitedRequests,
      "fields": _vm.invitedRequestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-file"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "workflow",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n          ")])
      }
    }], null, false, 2922140410)
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.invitedRequestsCount,
      "per-page": _vm.invitedRequestsPerPage
    },
    on: {
      "input": _vm.getInvitedRequests
    },
    model: {
      value: (_vm.invitedRequestsCurrentPage),
      callback: function($$v) {
        _vm.invitedRequestsCurrentPage = $$v
      },
      expression: "invitedRequestsCurrentPage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tabs.active == 'workflows') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reponsibleWorkflowsPerPage),
      expression: "reponsibleWorkflowsPerPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reponsibleWorkflowsPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getResponsibleWorkflows]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getResponsibleWorkflows.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.reponsibleWorkflowsFilter),
      callback: function($$v) {
        _vm.reponsibleWorkflowsFilter = $$v
      },
      expression: "reponsibleWorkflowsFilter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "workflows-table",
      "items": _vm.reponsibleWorkflows,
      "fields": _vm.reponsibleWorkflowsFields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-log-out"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "name",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value))]) : _vm._e()])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'WorkflowRequests',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n          ")])
      }
    }], null, false, 1234916202)
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.reponsibleWorkflowsCount,
      "per-page": _vm.reponsibleWorkflowsPerPage
    },
    on: {
      "input": _vm.getResponsibleWorkflows
    },
    model: {
      value: (_vm.reponsibleWorkflowsCurrentPage),
      callback: function($$v) {
        _vm.reponsibleWorkflowsCurrentPage = $$v
      },
      expression: "reponsibleWorkflowsCurrentPage"
    }
  })], 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19039b59"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile.vue
// module id = 1437
// module chunks = 1